/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-04-15 09:51:52
 * @LastEditors: linguang linguang@nextmar.com
 * @LastEditTime: 2025-04-15 17:07:20
 * @FilePath: /zeelool-nextjs/src/app/account/refer-a-friend/store/invite-friend-store.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { clickShareCount, getInviteHistory } from '@/api/account';
import logger from '@/utils/client-logger';
import { create } from 'zustand';

// 根据实际API响应定义邀请历史项的类型
interface InviteHistoryItem {
  id?: number;
  content?: string;
  created_at?: string;
  inviter_customer_id?: number;
  invitee_customer_id?: number;
  invitee_email?: string;
  point?: number;
  status?: number;
  registration_at?: string;
  verify_at?: string;
  order_no?: string;
  order_time?: string;
  account_name?: string;
  show_points?: string;
  [key: string]: any;
}

interface ShareStats {
  click_share: number;
  friends_referred: number;
  total_get_points: number;
  total_get_moneys: number;
}

interface Pagination {
  total: number;
  page: number;
  limit: number;
}

interface InviteFriendState {
  // 分享统计数据
  shareStats: ShareStats;
  // 邀请历史
  invitationList: InviteHistoryItem[];
  // 分页信息
  pagination: Pagination;
  // 是否正在加载
  isLoading: boolean;
  // 规则对话框状态
  isOpenRuleDialog: boolean;
  ruleDialogType: string;

  // 更新分享统计
  updateShareStats: (stats: Partial<ShareStats>) => void;
  // 更新邀请列表
  updateInvitationList: (list: InviteHistoryItem[]) => void;
  // 更新分页信息
  updatePagination: (pagination: Pagination) => void;
  // 刷新邀请历史数据及统计信息
  // WAP端是列表级联，WEB端是分页，支持重置页码
  refreshInvitationHistory: (isConcat?: boolean, page?: number) => Promise<void>;
  // 刷新分享统计
  refreshClickShareCount: () => Promise<void>;
  // 设置规则对话框打开状态
  setTriggerRuleDialog: (isOpenRuleDialog: boolean) => void;
  // 设置规则对话框类型
  setRuleDialogType: (ruleDialogType: string) => void;
  // 打开特定类型的规则对话框
  openRuleDialogWithType: (ruleDialogType: string) => void;
}

export const useInviteFriendStore = create<InviteFriendState>((set, get) => ({
  shareStats: {
    click_share: 0,
    friends_referred: 0,
    total_get_points: 0,
    total_get_moneys: 0,
  },
  invitationList: [],
  pagination: {
    total: 0,
    page: 1,
    limit: 10,
  },
  isLoading: false,
  // 从全局store迁移过来的状态
  isOpenRuleDialog: false,
  ruleDialogType: '',

  updateShareStats: (stats) =>
    set((state) => ({
      shareStats: { ...state.shareStats, ...stats },
    })),

  updateInvitationList: (list) => set({ invitationList: [...list] }),

  updatePagination: (pagination) => set({ pagination }),

  updatePaginationPage: (page) =>
    set((state) => ({
      pagination: { ...state.pagination, page },
    })),

  refreshClickShareCount: async () => {
    const state = get();
    const response = await clickShareCount();
    if (response.code === 200) {
      set({ shareStats: { ...state.shareStats, click_share: state.shareStats.click_share + 1 } });
    }
  },

  refreshInvitationHistory: async (isConcat = false, page?: number) => {
    const state = get();
    set({ isLoading: true });

    try {
      const response = await getInviteHistory({
        limit: state.pagination.limit,
        page: page || state.pagination.page,
      });

      if (response.code === 200) {
        set({
          invitationList: isConcat
            ? [...state.invitationList, ...(response.data?.data || [])]
            : [...(response.data?.data || [])],
          pagination: {
            ...state.pagination,
            total: Number(response.data?.total) || 0,
          },
          shareStats: {
            ...state.shareStats,
            click_share: Number(response.data?.click_share) || 0,
            friends_referred: Number(response.data?.friends_referred) || 0,
            total_get_points: Number(response.data?.total_get_points) || 0,
            total_get_moneys: Number(response.data?.total_get_moneys) || 0,
          },
        });
      }
    } catch (error) {
      logger.error('Failed to refresh invitation history:', error);
    } finally {
      set({ isLoading: false });
    }
  },

  // 从全局store迁移过来的方法
  setTriggerRuleDialog: (isOpenRuleDialog) => set({ isOpenRuleDialog }),
  setRuleDialogType: (ruleDialogType) => set({ ruleDialogType }),
  openRuleDialogWithType: (ruleDialogType) =>
    set({
      isOpenRuleDialog: true,
      ruleDialogType,
    }),
}));
